const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/i
const deeplinkPattern = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[\w-./?%&=]+$/i

export const validateURL = (_, value, callback) => {
  if (!value) {
    callback()
  } else if (!urlPattern.test(value)) {
    callback(new Error('Please enter a valid URL'))
  } else {
    callback()
  }
}

export const validateDeeplink = (_, value, callback) => {
  if (!value) {
    callback()
  } else if (!deeplinkPattern.test(value)) {
    callback(new Error('Please enter a valid deeplink'))
  } else {
    callback()
  }
}

export const validateURLOrDeeplink = (_, value, callback) => {
  if (!value) {
    callback()
  } else if (!urlPattern.test(value) && !deeplinkPattern.test(value)) {
    callback(new Error('Please enter a valid URL or deeplink'))
  } else {
    callback()
  }
}
